import { observer } from "mobx-react-lite";
import React, { useState, FormEvent, useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { Button, Form, Segment } from "semantic-ui-react";
import { ICustomer } from "../../../app/models/customer";
import CustomerStore from "../../../app/stores/customerStore";

const CustomerCreateForm: React.FC<RouteComponentProps> = ({ history }) => {
  const customerStore = useContext(CustomerStore);
  const { createCustomer, submitting, customer, loadCustomers } = customerStore;

  // load customers in the registry at first
  useEffect(() => {
    loadCustomers();
  }, []);

  const [newCustomer, setNewCustomer] = useState<ICustomer>({
    id: "",
    createdAt: "",
    updatedAt: "",
    name: "",
    abn: "",
    address: "",
    contactName: "",
    email: "",
    phone: "",
    remark: "",
  });

  const handleSubmit = () => {
    createCustomer(newCustomer).then(() => {
      history.push(`/dailymanagement/customer`);
    });
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setNewCustomer({ ...newCustomer, [name]: value });
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Input
          label="Name"
          required
          onChange={handleInputChange}
          name="name"
          placeholder="Name"
          value={newCustomer.name}
        />
        <Form.Input
          label="ABN"
          name="abn"
          onChange={handleInputChange}
          placeholder="ABN"
          value={newCustomer.abn}
        />
        <Form.Input
          label="Address"
          name="address"
          onChange={handleInputChange}
          placeholder="Address"
          value={newCustomer.address}
        />
        <Form.Input
          label="Contact Name"
          name="contactName"
          onChange={handleInputChange}
          placeholder="Contact Name"
          value={newCustomer.contactName}
        />
        <Form.Input
          label="Email"
          required
          name="email"
          onChange={handleInputChange}
          placeholder="Email"
          value={newCustomer.email}
        />
        <Form.Input
          label="Phone"
          name="phone"
          onChange={handleInputChange}
          required
          placeholder="Phone"
          value={newCustomer.phone}
        />
        <Form.TextArea
          label="Remark"
          name="remark"
          onChange={handleInputChange}
          placeholder="Remark"
          value={newCustomer.remark}
        />

        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/dailymanagement/customer")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(CustomerCreateForm);
